import Tabs from './tabs'
import Tab from './tab'
import TabList from './tabList'
import TabPanel from './tabPanel'

export {
  Tabs,
  Tab,
  TabList,
  TabPanel,
}



// WEBPACK FOOTER //
// ./src/Tabs/index.js